import { render, staticRenderFns } from "./TaskComments.vue?vue&type=template&id=128f1cdc&scoped=true&"
import script from "./TaskComments.vue?vue&type=script&lang=js&"
export * from "./TaskComments.vue?vue&type=script&lang=js&"
import style0 from "./TaskComments.vue?vue&type=style&index=0&id=128f1cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f1cdc",
  null
  
)

export default component.exports